var $0c19c7a2667b34f6$exports = {};
$0c19c7a2667b34f6$exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`,
    "valid": `(va\u{17E}e\u{107}e)`
};


export {$0c19c7a2667b34f6$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
